import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import OrganisationManagementService from '@/services/OrganisationManagementService'

interface AssignPropertyParams {
  organisationId: string
  accommodationId: number
  isOnboarding: boolean
}

export function useAssignProperty() {
  const queryClient = useQueryClient()

  const {
    isPending: assignPropertyLoading,
    isSuccess: assignPropertySuccess,
    isError: assignPropertyError,
    mutate: assignProperty,
  } = useMutation({
    mutationFn: ({ accommodationId, isOnboarding }: AssignPropertyParams): Promise<AxiosResponse> =>
      OrganisationManagementService.postOrganisationAssignments({
        accommodationId,
        isOnboarding,
      }),
    onSuccess: (_data, { organisationId, accommodationId }: AssignPropertyParams) => {
      queryClient.setQueryData<number[]>(['organisationAssignments', organisationId], oldData =>
        Array.isArray(oldData) ? [...oldData, accommodationId] : oldData
      )
      queryClient.invalidateQueries({ queryKey: ['organisationAccommodations', organisationId] })
    },
  })

  return {
    assignPropertyLoading,
    assignPropertySuccess,
    assignPropertyError,
    assignProperty,
  }
}
